export default (function (parent) {
  $(".overlapping_top, .overlapping_bottom, .extra-pad-bottom, .extra-mar-bottom").each(function () {
    if ($(this).parents(parent).length) {
      var $overlap_top, $overlap_top_ar, $ar_pad_top, $default_pad_top, $default_pad_bottom, $overlap_bottom, $overlap_bottom_ar, $ar_pad_bottom, $extra_pad_bottom, $extra_pad_bottom_ar, $ar_extra_pad_bottom, $extra_mar_bottom, $extra_mar_bottom_ar, $ar_extra_mar_bottom;
      $overlap_top = $(this).data("overlapping_top");
      $(this).attr('data-default_pad_top', parseInt($(this).css("padding-top")));
      $default_pad_top = $(this).data("default_pad_top");

      if ($overlap_top) {
        $overlap_top_ar = $overlap_top.split("|");
        $ar_pad_top = [];

        for (var i = 0; i < 3; i++) {
          $ar_pad_top[i] = parseInt($overlap_top_ar[i]) + $default_pad_top;
        }
      }

      $overlap_bottom = $(this).data("overlapping_bottom");
      $(this).attr('data-default_pad_bottom', parseInt($(this).css("padding-bottom")));
      $default_pad_bottom = $(this).data("default_pad_bottom");

      if ($overlap_bottom) {
        $overlap_bottom_ar = $overlap_bottom.split("|");
        $ar_pad_bottom = [];

        for (var i = 0; i < 3; i++) {
          $ar_pad_bottom[i] = parseInt($overlap_bottom_ar[i]) + $default_pad_bottom;
        }
      }

      $extra_pad_bottom = $(this).data("extra_pad_bottom");

      if ($extra_pad_bottom) {
        $extra_pad_bottom_ar = $extra_pad_bottom.split('|');
        $ar_extra_pad_bottom = [];

        for (var i = 0; i < 3; i++) {
          $ar_extra_pad_bottom[i] = parseInt($extra_pad_bottom_ar[i]);
        }
      }

      $extra_mar_bottom = $(this).data("extra_mar_bottom");

      if ($extra_mar_bottom) {
        $extra_mar_bottom_ar = $extra_mar_bottom.split('|');
        $ar_extra_mar_bottom = [];

        for (var i = 0; i < 3; i++) {
          $ar_extra_mar_bottom[i] = parseInt($extra_mar_bottom_ar[i]);
        }
      }

      if ($overlap_top && $overlap_top !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("padding-top", $ar_pad_top[0] + "px");
          $(this).css("margin-top", "-" + $overlap_top_ar[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("padding-top", $ar_pad_top[1] + "px");
          $(this).css("margin-top", "-" + $overlap_top_ar[1] + "px");
        } else {
          $(this).css("padding-top", $ar_pad_top[2] + "px");
          $(this).css("margin-top", "-" + $overlap_top_ar[2] + "px");
        }
      }

      if ($overlap_bottom && $overlap_bottom !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("padding-bottom", $ar_pad_bottom[0] + "px");
          $(this).css("margin-bottom", "-" + $overlap_bottom_ar[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("padding-bottom", $ar_pad_bottom[1] + "px");
          $(this).css("margin-bottom", "-" + $overlap_bottom_ar[1] + "px");
        } else {
          $(this).css("padding-bottom", $ar_pad_bottom[2] + "px");
          $(this).css("margin-bottom", "-" + $overlap_bottom_ar[2] + "px");
        }
      }

      if ($extra_pad_bottom && $extra_pad_bottom !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("padding-bottom", $ar_extra_pad_bottom[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("padding-bottom", $ar_extra_pad_bottom[1] + "px");
        } else {
          $(this).css("padding-bottom", $ar_extra_pad_bottom[2] + "px");
        }
      }

      if ($extra_mar_bottom && $extra_mar_bottom !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("margin-bottom", $ar_extra_mar_bottom[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("margin-bottom", $ar_extra_mar_bottom[1] + "px");
        } else {
          $(this).css("margin-bottom", $ar_extra_mar_bottom[2] + "px");
        }
      }
    }
  });
  $(".bottom-inner-indent").each(function () {
    if ($(this).parents(parent).length) {
      var $bottom_inner_indent, $bottom_inner_indent_ar, $ar_mar_bot;
      $bottom_inner_indent = $(this).data("bottom_inner_indent");

      if ($bottom_inner_indent) {
        $bottom_inner_indent_ar = $bottom_inner_indent.split("|");
        $ar_mar_bot = [];

        for (var i = 0; i < 3; i++) {
          $ar_mar_bot[i] = parseInt($bottom_inner_indent_ar[i]);
        }

        if ($bottom_inner_indent && $bottom_inner_indent !== '') {
          if (window.matchMedia('(min-width: 992px)').matches) {
            $(this).find(".bottom-inner-indent__inner").css("margin-bottom", "-" + $ar_mar_bot[0] + "px");
            $(this).next().css("margin-top", $ar_mar_bot[0] + "px");
          } else if (window.matchMedia('(min-width: 768px)').matches) {
            $(this).find(".bottom-inner-indent__inner").css("margin-bottom", "-" + $ar_mar_bot[1] + "px");
            $(this).next().css("margin-top", $ar_mar_bot[1] + "px");
          } else {
            $(this).find(".bottom-inner-indent__inner").css("margin-bottom", "-" + $ar_mar_bot[2] + "px");
            $(this).next().css("margin-top", $ar_mar_bot[2] - 72 + "px");
          }
        }
      }
    }
  });
  $(".item-img--overlap-top").each(function () {
    if ($(this).parents(parent).length) {
      var $overlap_top, $overlap_top_ar, $ar_mar_top;
      $overlap_top = $(this).data("margin_top");

      if ($overlap_top) {
        $overlap_top_ar = $overlap_top.split("|");
        $ar_mar_top = [];

        for (var i = 0; i < 3; i++) {
          $ar_mar_top[i] = parseInt($overlap_top_ar[i]);
        }
      }

      if ($overlap_top && $overlap_top !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("margin-top", "-" + $ar_mar_top[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("margin-top", "-" + $ar_mar_top[1] + "px");
        } else {
          $(this).css("margin-top", "-" + $ar_mar_top[2] + "px");
        }
      }
    }
  });
  $(".custom_font_size").each(function () {
    if ($(this).parents(parent).length) {
      var $font_size, $font_size_ar;
      $font_size = $(this).data("font_size");

      if ($font_size && $font_size !== '') {
        $font_size_ar = $font_size.split("|");

        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).attr('style', 'font-size: ' + $font_size_ar[0] + 'px !important');
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).attr('style', 'font-size: ' + $font_size_ar[1] + 'px !important');
        } else {
          $(this).attr('style', 'font-size: ' + $font_size_ar[2] + 'px !important');
        }
      }
    }
  });
});